<template>
  <ul class="site">
  </ul>
</template>

<script>
export default {
  name: 'SiteMobile',
  data: function () {
    return {
      investment: `/`
    }
  },
  methods: {
    clearStorage: function () {
      sessionStorage.clear()
    }
  }
}

</script>

<style lang="scss" scoped>
  .site__link--color,
  .about-us__link--color {
    color: $white
  }

  .site__item {
    margin: 2.5em 0;
  }

  .site__item:hover,
  .site__link--active {
    font-weight: bold;
  }

  .site__link--active::before {
    content: '';
    width: 6%;
    height: 28px;
    position: absolute;
    left: 0;
    background: $green;
  }

  .site__item::before,
  .about-us__item::before {
    content: ''
  }

  .site__item--color {
    color: $white
  }

  .about-us__item {
    margin: 1.5em 0;
  }

  .about-us__link--active {
    font-weight: bold;
  }

  .about-us__link--active::before {
    content: '';
    width: 15%;
    position: absolute;
    height: 20px;
    background: $green;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Menu/Mobile/SiteMobile.vue